import React, { useEffect, useState } from 'react';

import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
} from '@mui/material';

import { RuleCondition, USER_TAG_OPTIONS, labelForUserTagValue } from '~/consts/agentHub';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => void;
  existingConditions: RuleCondition['value'];
}

function AgentHubCommissionsUserTagsInput({ setCreatedConditions, existingConditions }: Props) {
  const allowedValues = new Set(USER_TAG_OPTIONS.map((o) => o.value));
  const [selectedTags, setSelectedTags] = useState<Array<string>>(
    (existingConditions?.map((cond) => cond.value as string) || []).filter((v) => allowedValues.has(v)),
  );

  useEffect(() => {
    setCreatedConditions(
      {
        type: 'tags',
        value: selectedTags.map((tag) => ({
          value: tag,
          label: labelForUserTagValue(tag),
        })),
      },
      true,
    );
  }, [setCreatedConditions, selectedTags]);

  function handleChange(event: SelectChangeEvent<Array<string> | string>) {
    const {
      target: { value },
    } = event;

    setSelectedTags(typeof value === 'string' ? value.split(',') : value);
  }

  function renderValueText() {
    if (selectedTags.length === 0) {
      return '';
    }
    if (selectedTags.length === 1) {
      return labelForUserTagValue(selectedTags[0]);
    }

    return `${selectedTags.length} tags selected`;
  }

  return (
    <Stack gap={2}>
      <FormControl fullWidth>
        <InputLabel id="agent-hub-commissions-user-tags-input-label">User tags</InputLabel>
        <Select<Array<string>>
          labelId="agent-hub-commissions-user-tags-input-label"
          multiple
          value={selectedTags}
          onChange={handleChange}
          input={<OutlinedInput label="User tags" />}
          renderValue={renderValueText}
          sx={{ borderRadius: 0.5 }}
        >
          {USER_TAG_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox checked={selectedTags.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}

export default AgentHubCommissionsUserTagsInput;
